// `Symbol.species` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.species
require('../internals/define-well-known-symbol')('species');
